/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * MOTUS Bug Tracker API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AttachmentSaveInput,
  AuditLog,
  Category,
  CategoryInput,
  CategoryReorderInput,
  CategoryUpdate,
  Comment,
  CommentInput,
  Draft,
  DraftApplyInput,
  HealthStatus,
  Issue,
  IssueInput,
  IssueUpdate,
  IssuesSummary,
  LinkDuplicateInput,
  ListAuditLogsParams,
  ListCategoriesParams,
  ListDraftsParams,
  ListIssuesParams,
  ListReportsParams,
  ListStatusesParams,
  LookupLinkRequest,
  LookupLinkResult,
  LookupReportsParams,
  OAuthConnection,
  OAuthConsentDecision,
  OAuthConsentRequest,
  Report,
  ReportAttachment,
  ReportInput,
  ReportUpdate,
  ReportWithComments,
  Status,
  StatusInput,
  StatusReorderInput,
  StatusUpdate,
  UploadUrlRequest,
  UploadUrlResult,
  WhatsChangedEntry,
  WhatsChangedEntryInput,
  WhatsChangedEntryUpdate,
  WhatsChangedReorderInput
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCategoriesUrl = (params?: ListCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/categories?${stringifiedParams}` : `/api/categories`
}

/**
 * @summary List categories (public). Returns all by default; pass activeOnly=true to filter out deactivated.
 */
export const listCategories = async (params?: ListCategoriesParams, options?: Parameters<typeof customFetch>[1]): Promise<Category[]> => {

  return customFetch<Category[]>(getListCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCategoriesQueryKey = (params?: ListCategoriesParams,) => {
    return [
    `/api/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(params?: ListCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({ signal }) => listCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type ListCategoriesQueryError = ErrorType<unknown>


export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
 params: undefined |  ListCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategories>>,
          TError,
          Awaited<ReturnType<typeof listCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
 params?: ListCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategories>>,
          TError,
          Awaited<ReturnType<typeof listCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
 params?: ListCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List categories (public). Returns all by default; pass activeOnly=true to filter out deactivated.
 */

export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
 params?: ListCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCategoryUrl = () => {




  return `/api/categories`
}

/**
 * @summary Create a category (staff only)
 */
export const createCategory = async (categoryInput: CategoryInput, options?: Parameters<typeof customFetch>[1]): Promise<Category> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Category>(getCreateCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(categoryInput)
  }
);}





export const getCreateCategoryMutationKey = () => ['createCategory'] as const;

export const getCreateCategoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,CreateCategoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,CreateCategoryMutationVariables, TContext> => {

const mutationKey = getCreateCategoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, CreateCategoryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
    export type CreateCategoryMutationBody = BodyType<CategoryInput>
    export type CreateCategoryMutationError = ErrorType<void>
    export type CreateCategoryMutationVariables = {data: BodyType<CategoryInput>}

    /**
 * @summary Create a category (staff only)
 */
export const useCreateCategory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,CreateCategoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCategory>>,
        TError,
        CreateCategoryMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCategoryMutationOptions(options), queryClient);
    }

export const getReorderCategoriesUrl = () => {




  return `/api/categories/reorder`
}

/**
 * @summary Bulk-reorder categories (staff only)
 */
export const reorderCategories = async (categoryReorderInput: CategoryReorderInput, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getReorderCategoriesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(categoryReorderInput)
  }
);}





export const getReorderCategoriesMutationKey = () => ['reorderCategories'] as const;

export const getReorderCategoriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderCategories>>, TError,ReorderCategoriesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderCategories>>, TError,ReorderCategoriesMutationVariables, TContext> => {

const mutationKey = getReorderCategoriesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderCategories>>, ReorderCategoriesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reorderCategories(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderCategories>>>
    export type ReorderCategoriesMutationBody = BodyType<CategoryReorderInput>
    export type ReorderCategoriesMutationError = ErrorType<unknown>
    export type ReorderCategoriesMutationVariables = {data: BodyType<CategoryReorderInput>}

    /**
 * @summary Bulk-reorder categories (staff only)
 */
export const useReorderCategories = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderCategories>>, TError,ReorderCategoriesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderCategories>>,
        TError,
        ReorderCategoriesMutationVariables,
        TContext
      > => {
      return useMutation(getReorderCategoriesMutationOptions(options), queryClient);
    }

export const getUpdateCategoryUrl = (id: number,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Update a category (staff only). Rename, deactivate (isActive=false), or change sortOrder. All fields optional.
 */
export const updateCategory = async (id: number,
    categoryUpdate: CategoryUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Category> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Category>(getUpdateCategoryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(categoryUpdate)
  }
);}





export const getUpdateCategoryMutationKey = () => ['updateCategory'] as const;

export const getUpdateCategoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,UpdateCategoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,UpdateCategoryMutationVariables, TContext> => {

const mutationKey = getUpdateCategoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, UpdateCategoryMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
    export type UpdateCategoryMutationBody = BodyType<CategoryUpdate>
    export type UpdateCategoryMutationError = ErrorType<void>
    export type UpdateCategoryMutationVariables = {id: number;data: BodyType<CategoryUpdate>}

    /**
 * @summary Update a category (staff only). Rename, deactivate (isActive=false), or change sortOrder. All fields optional.
 */
export const useUpdateCategory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,UpdateCategoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCategory>>,
        TError,
        UpdateCategoryMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCategoryMutationOptions(options), queryClient);
    }

export const getDeleteCategoryUrl = (id: number,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Delete a category (staff only)
 */
export const deleteCategory = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteCategoryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCategoryMutationKey = () => ['deleteCategory'] as const;

export const getDeleteCategoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,DeleteCategoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,DeleteCategoryMutationVariables, TContext> => {

const mutationKey = getDeleteCategoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, DeleteCategoryMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteCategory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>

    export type DeleteCategoryMutationError = ErrorType<void>
    export type DeleteCategoryMutationVariables = {id: number}

    /**
 * @summary Delete a category (staff only)
 */
export const useDeleteCategory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,DeleteCategoryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCategory>>,
        TError,
        DeleteCategoryMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCategoryMutationOptions(options), queryClient);
    }

export const getListStatusesUrl = (params?: ListStatusesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/statuses?${stringifiedParams}` : `/api/statuses`
}

/**
 * @summary List statuses (public). Always returns all statuses including inactive ones (callers filter client-side).
 */
export const listStatuses = async (params?: ListStatusesParams, options?: Parameters<typeof customFetch>[1]): Promise<Status[]> => {

  return customFetch<Status[]>(getListStatusesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStatusesQueryKey = (params?: ListStatusesParams,) => {
    return [
    `/api/statuses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStatusesQueryOptions = <TData = Awaited<ReturnType<typeof listStatuses>>, TError = ErrorType<unknown>>(params?: ListStatusesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStatusesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStatuses>>> = ({ signal }) => listStatuses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof listStatuses>>>
export type ListStatusesQueryError = ErrorType<unknown>


export function useListStatuses<TData = Awaited<ReturnType<typeof listStatuses>>, TError = ErrorType<unknown>>(
 params: undefined |  ListStatusesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStatuses>>,
          TError,
          Awaited<ReturnType<typeof listStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStatuses<TData = Awaited<ReturnType<typeof listStatuses>>, TError = ErrorType<unknown>>(
 params?: ListStatusesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStatuses>>,
          TError,
          Awaited<ReturnType<typeof listStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStatuses<TData = Awaited<ReturnType<typeof listStatuses>>, TError = ErrorType<unknown>>(
 params?: ListStatusesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List statuses (public). Always returns all statuses including inactive ones (callers filter client-side).
 */

export function useListStatuses<TData = Awaited<ReturnType<typeof listStatuses>>, TError = ErrorType<unknown>>(
 params?: ListStatusesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStatusesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateStatusUrl = () => {




  return `/api/statuses`
}

/**
 * @summary Create a status (staff only)
 */
export const createStatus = async (statusInput: StatusInput, options?: Parameters<typeof customFetch>[1]): Promise<Status> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Status>(getCreateStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(statusInput)
  }
);}





export const getCreateStatusMutationKey = () => ['createStatus'] as const;

export const getCreateStatusMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStatus>>, TError,CreateStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStatus>>, TError,CreateStatusMutationVariables, TContext> => {

const mutationKey = getCreateStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStatus>>, CreateStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof createStatus>>>
    export type CreateStatusMutationBody = BodyType<StatusInput>
    export type CreateStatusMutationError = ErrorType<void>
    export type CreateStatusMutationVariables = {data: BodyType<StatusInput>}

    /**
 * @summary Create a status (staff only)
 */
export const useCreateStatus = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStatus>>, TError,CreateStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStatus>>,
        TError,
        CreateStatusMutationVariables,
        TContext
      > => {
      return useMutation(getCreateStatusMutationOptions(options), queryClient);
    }

export const getReorderStatusesUrl = () => {




  return `/api/statuses/reorder`
}

/**
 * @summary Bulk-reorder statuses (staff only)
 */
export const reorderStatuses = async (statusReorderInput: StatusReorderInput, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getReorderStatusesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(statusReorderInput)
  }
);}





export const getReorderStatusesMutationKey = () => ['reorderStatuses'] as const;

export const getReorderStatusesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderStatuses>>, TError,ReorderStatusesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderStatuses>>, TError,ReorderStatusesMutationVariables, TContext> => {

const mutationKey = getReorderStatusesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderStatuses>>, ReorderStatusesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reorderStatuses(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderStatuses>>>
    export type ReorderStatusesMutationBody = BodyType<StatusReorderInput>
    export type ReorderStatusesMutationError = ErrorType<unknown>
    export type ReorderStatusesMutationVariables = {data: BodyType<StatusReorderInput>}

    /**
 * @summary Bulk-reorder statuses (staff only)
 */
export const useReorderStatuses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderStatuses>>, TError,ReorderStatusesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderStatuses>>,
        TError,
        ReorderStatusesMutationVariables,
        TContext
      > => {
      return useMutation(getReorderStatusesMutationOptions(options), queryClient);
    }

export const getUpdateStatusUrl = (id: number,) => {




  return `/api/statuses/${id}`
}

/**
 * @summary Update a status (staff only). To deactivate, set isActive=false.
 */
export const updateStatus = async (id: number,
    statusUpdate: StatusUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Status> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Status>(getUpdateStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(statusUpdate)
  }
);}





export const getUpdateStatusMutationKey = () => ['updateStatus'] as const;

export const getUpdateStatusMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStatus>>, TError,UpdateStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStatus>>, TError,UpdateStatusMutationVariables, TContext> => {

const mutationKey = getUpdateStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStatus>>, UpdateStatusMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateStatus>>>
    export type UpdateStatusMutationBody = BodyType<StatusUpdate>
    export type UpdateStatusMutationError = ErrorType<void>
    export type UpdateStatusMutationVariables = {id: number;data: BodyType<StatusUpdate>}

    /**
 * @summary Update a status (staff only). To deactivate, set isActive=false.
 */
export const useUpdateStatus = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStatus>>, TError,UpdateStatusMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStatus>>,
        TError,
        UpdateStatusMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateStatusMutationOptions(options), queryClient);
    }

export const getListIssuesUrl = (params?: ListIssuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/issues?${stringifiedParams}` : `/api/issues`
}

/**
 * @summary List all known MOTUS issues (public)
 */
export const listIssues = async (params?: ListIssuesParams, options?: Parameters<typeof customFetch>[1]): Promise<Issue[]> => {

  return customFetch<Issue[]>(getListIssuesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIssuesQueryKey = (params?: ListIssuesParams,) => {
    return [
    `/api/issues`, ...(params ? [params] : [])
    ] as const;
    }


export const getListIssuesQueryOptions = <TData = Awaited<ReturnType<typeof listIssues>>, TError = ErrorType<unknown>>(params?: ListIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIssuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIssues>>> = ({ signal }) => listIssues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIssues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIssuesQueryResult = NonNullable<Awaited<ReturnType<typeof listIssues>>>
export type ListIssuesQueryError = ErrorType<unknown>


export function useListIssues<TData = Awaited<ReturnType<typeof listIssues>>, TError = ErrorType<unknown>>(
 params: undefined |  ListIssuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIssues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIssues>>,
          TError,
          Awaited<ReturnType<typeof listIssues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIssues<TData = Awaited<ReturnType<typeof listIssues>>, TError = ErrorType<unknown>>(
 params?: ListIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIssues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIssues>>,
          TError,
          Awaited<ReturnType<typeof listIssues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIssues<TData = Awaited<ReturnType<typeof listIssues>>, TError = ErrorType<unknown>>(
 params?: ListIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all known MOTUS issues (public)
 */

export function useListIssues<TData = Awaited<ReturnType<typeof listIssues>>, TError = ErrorType<unknown>>(
 params?: ListIssuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIssues>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIssuesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateIssueUrl = () => {




  return `/api/issues`
}

/**
 * @summary Create a known issue (staff only)
 */
export const createIssue = async (issueInput: IssueInput, options?: Parameters<typeof customFetch>[1]): Promise<Issue> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Issue>(getCreateIssueUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(issueInput)
  }
);}





export const getCreateIssueMutationKey = () => ['createIssue'] as const;

export const getCreateIssueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIssue>>, TError,CreateIssueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createIssue>>, TError,CreateIssueMutationVariables, TContext> => {

const mutationKey = getCreateIssueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIssue>>, CreateIssueMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createIssue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateIssueMutationResult = NonNullable<Awaited<ReturnType<typeof createIssue>>>
    export type CreateIssueMutationBody = BodyType<IssueInput>
    export type CreateIssueMutationError = ErrorType<unknown>
    export type CreateIssueMutationVariables = {data: BodyType<IssueInput>}

    /**
 * @summary Create a known issue (staff only)
 */
export const useCreateIssue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIssue>>, TError,CreateIssueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createIssue>>,
        TError,
        CreateIssueMutationVariables,
        TContext
      > => {
      return useMutation(getCreateIssueMutationOptions(options), queryClient);
    }

export const getGetIssueUrl = (id: number,) => {




  return `/api/issues/${id}`
}

/**
 * @summary Get a single known issue
 */
export const getIssue = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Issue> => {

  return customFetch<Issue>(getGetIssueUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIssueQueryKey = (id: number,) => {
    return [
    `/api/issues/${id}`
    ] as const;
    }


export const getGetIssueQueryOptions = <TData = Awaited<ReturnType<typeof getIssue>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIssueQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIssue>>> = ({ signal }) => getIssue(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIssue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIssueQueryResult = NonNullable<Awaited<ReturnType<typeof getIssue>>>
export type GetIssueQueryError = ErrorType<void>


export function useGetIssue<TData = Awaited<ReturnType<typeof getIssue>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssue>>,
          TError,
          Awaited<ReturnType<typeof getIssue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssue<TData = Awaited<ReturnType<typeof getIssue>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssue>>,
          TError,
          Awaited<ReturnType<typeof getIssue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssue<TData = Awaited<ReturnType<typeof getIssue>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single known issue
 */

export function useGetIssue<TData = Awaited<ReturnType<typeof getIssue>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIssueQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateIssueUrl = (id: number,) => {




  return `/api/issues/${id}`
}

/**
 * @summary Update a known issue (staff only)
 */
export const updateIssue = async (id: number,
    issueUpdate: IssueUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Issue> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Issue>(getUpdateIssueUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(issueUpdate)
  }
);}





export const getUpdateIssueMutationKey = () => ['updateIssue'] as const;

export const getUpdateIssueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIssue>>, TError,UpdateIssueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIssue>>, TError,UpdateIssueMutationVariables, TContext> => {

const mutationKey = getUpdateIssueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIssue>>, UpdateIssueMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateIssue(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateIssueMutationResult = NonNullable<Awaited<ReturnType<typeof updateIssue>>>
    export type UpdateIssueMutationBody = BodyType<IssueUpdate>
    export type UpdateIssueMutationError = ErrorType<unknown>
    export type UpdateIssueMutationVariables = {id: number;data: BodyType<IssueUpdate>}

    /**
 * @summary Update a known issue (staff only)
 */
export const useUpdateIssue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIssue>>, TError,UpdateIssueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateIssue>>,
        TError,
        UpdateIssueMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateIssueMutationOptions(options), queryClient);
    }

export const getDeleteIssueUrl = (id: number,) => {




  return `/api/issues/${id}`
}

/**
 * @summary Delete a known issue (staff only)
 */
export const deleteIssue = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteIssueUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteIssueMutationKey = () => ['deleteIssue'] as const;

export const getDeleteIssueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIssue>>, TError,DeleteIssueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIssue>>, TError,DeleteIssueMutationVariables, TContext> => {

const mutationKey = getDeleteIssueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIssue>>, DeleteIssueMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteIssue(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIssueMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIssue>>>

    export type DeleteIssueMutationError = ErrorType<unknown>
    export type DeleteIssueMutationVariables = {id: number}

    /**
 * @summary Delete a known issue (staff only)
 */
export const useDeleteIssue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIssue>>, TError,DeleteIssueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIssue>>,
        TError,
        DeleteIssueMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteIssueMutationOptions(options), queryClient);
    }

export const getGetIssuesSummaryUrl = () => {




  return `/api/issues/summary`
}

/**
 * @summary Get count of issues by status (public)
 */
export const getIssuesSummary = async ( options?: Parameters<typeof customFetch>[1]): Promise<IssuesSummary> => {

  return customFetch<IssuesSummary>(getGetIssuesSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIssuesSummaryQueryKey = () => {
    return [
    `/api/issues/summary`
    ] as const;
    }


export const getGetIssuesSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getIssuesSummary>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuesSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIssuesSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIssuesSummary>>> = ({ signal }) => getIssuesSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIssuesSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIssuesSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getIssuesSummary>>>
export type GetIssuesSummaryQueryError = ErrorType<unknown>


export function useGetIssuesSummary<TData = Awaited<ReturnType<typeof getIssuesSummary>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuesSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssuesSummary>>,
          TError,
          Awaited<ReturnType<typeof getIssuesSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssuesSummary<TData = Awaited<ReturnType<typeof getIssuesSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuesSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssuesSummary>>,
          TError,
          Awaited<ReturnType<typeof getIssuesSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIssuesSummary<TData = Awaited<ReturnType<typeof getIssuesSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuesSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get count of issues by status (public)
 */

export function useGetIssuesSummary<TData = Awaited<ReturnType<typeof getIssuesSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssuesSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIssuesSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWhatsChangedUrl = () => {




  return `/api/whats-changed`
}

/**
 * @summary List all What's Changed entries (public)
 */
export const listWhatsChanged = async ( options?: Parameters<typeof customFetch>[1]): Promise<WhatsChangedEntry[]> => {

  return customFetch<WhatsChangedEntry[]>(getListWhatsChangedUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWhatsChangedQueryKey = () => {
    return [
    `/api/whats-changed`
    ] as const;
    }


export const getListWhatsChangedQueryOptions = <TData = Awaited<ReturnType<typeof listWhatsChanged>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhatsChanged>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWhatsChangedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhatsChanged>>> = ({ signal }) => listWhatsChanged({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWhatsChanged>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWhatsChangedQueryResult = NonNullable<Awaited<ReturnType<typeof listWhatsChanged>>>
export type ListWhatsChangedQueryError = ErrorType<unknown>


export function useListWhatsChanged<TData = Awaited<ReturnType<typeof listWhatsChanged>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhatsChanged>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWhatsChanged>>,
          TError,
          Awaited<ReturnType<typeof listWhatsChanged>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWhatsChanged<TData = Awaited<ReturnType<typeof listWhatsChanged>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhatsChanged>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWhatsChanged>>,
          TError,
          Awaited<ReturnType<typeof listWhatsChanged>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWhatsChanged<TData = Awaited<ReturnType<typeof listWhatsChanged>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhatsChanged>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all What's Changed entries (public)
 */

export function useListWhatsChanged<TData = Awaited<ReturnType<typeof listWhatsChanged>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhatsChanged>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWhatsChangedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateWhatsChangedEntryUrl = () => {




  return `/api/whats-changed`
}

/**
 * @summary Create a What's Changed entry (staff only)
 */
export const createWhatsChangedEntry = async (whatsChangedEntryInput: WhatsChangedEntryInput, options?: Parameters<typeof customFetch>[1]): Promise<WhatsChangedEntry> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WhatsChangedEntry>(getCreateWhatsChangedEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(whatsChangedEntryInput)
  }
);}





export const getCreateWhatsChangedEntryMutationKey = () => ['createWhatsChangedEntry'] as const;

export const getCreateWhatsChangedEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsChangedEntry>>, TError,CreateWhatsChangedEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWhatsChangedEntry>>, TError,CreateWhatsChangedEntryMutationVariables, TContext> => {

const mutationKey = getCreateWhatsChangedEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWhatsChangedEntry>>, CreateWhatsChangedEntryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWhatsChangedEntry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWhatsChangedEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createWhatsChangedEntry>>>
    export type CreateWhatsChangedEntryMutationBody = BodyType<WhatsChangedEntryInput>
    export type CreateWhatsChangedEntryMutationError = ErrorType<unknown>
    export type CreateWhatsChangedEntryMutationVariables = {data: BodyType<WhatsChangedEntryInput>}

    /**
 * @summary Create a What's Changed entry (staff only)
 */
export const useCreateWhatsChangedEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWhatsChangedEntry>>, TError,CreateWhatsChangedEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWhatsChangedEntry>>,
        TError,
        CreateWhatsChangedEntryMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWhatsChangedEntryMutationOptions(options), queryClient);
    }

export const getReorderWhatsChangedEntriesUrl = () => {




  return `/api/whats-changed/reorder`
}

/**
 * @summary Bulk-reorder What's Changed entries (staff only)
 */
export const reorderWhatsChangedEntries = async (whatsChangedReorderInput: WhatsChangedReorderInput, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getReorderWhatsChangedEntriesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(whatsChangedReorderInput)
  }
);}





export const getReorderWhatsChangedEntriesMutationKey = () => ['reorderWhatsChangedEntries'] as const;

export const getReorderWhatsChangedEntriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderWhatsChangedEntries>>, TError,ReorderWhatsChangedEntriesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderWhatsChangedEntries>>, TError,ReorderWhatsChangedEntriesMutationVariables, TContext> => {

const mutationKey = getReorderWhatsChangedEntriesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderWhatsChangedEntries>>, ReorderWhatsChangedEntriesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reorderWhatsChangedEntries(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderWhatsChangedEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderWhatsChangedEntries>>>
    export type ReorderWhatsChangedEntriesMutationBody = BodyType<WhatsChangedReorderInput>
    export type ReorderWhatsChangedEntriesMutationError = ErrorType<unknown>
    export type ReorderWhatsChangedEntriesMutationVariables = {data: BodyType<WhatsChangedReorderInput>}

    /**
 * @summary Bulk-reorder What's Changed entries (staff only)
 */
export const useReorderWhatsChangedEntries = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderWhatsChangedEntries>>, TError,ReorderWhatsChangedEntriesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderWhatsChangedEntries>>,
        TError,
        ReorderWhatsChangedEntriesMutationVariables,
        TContext
      > => {
      return useMutation(getReorderWhatsChangedEntriesMutationOptions(options), queryClient);
    }

export const getUpdateWhatsChangedEntryUrl = (id: number,) => {




  return `/api/whats-changed/${id}`
}

/**
 * @summary Update a What's Changed entry (staff only)
 */
export const updateWhatsChangedEntry = async (id: number,
    whatsChangedEntryUpdate: WhatsChangedEntryUpdate, options?: Parameters<typeof customFetch>[1]): Promise<WhatsChangedEntry> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WhatsChangedEntry>(getUpdateWhatsChangedEntryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(whatsChangedEntryUpdate)
  }
);}





export const getUpdateWhatsChangedEntryMutationKey = () => ['updateWhatsChangedEntry'] as const;

export const getUpdateWhatsChangedEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatsChangedEntry>>, TError,UpdateWhatsChangedEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWhatsChangedEntry>>, TError,UpdateWhatsChangedEntryMutationVariables, TContext> => {

const mutationKey = getUpdateWhatsChangedEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWhatsChangedEntry>>, UpdateWhatsChangedEntryMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWhatsChangedEntry(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWhatsChangedEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateWhatsChangedEntry>>>
    export type UpdateWhatsChangedEntryMutationBody = BodyType<WhatsChangedEntryUpdate>
    export type UpdateWhatsChangedEntryMutationError = ErrorType<unknown>
    export type UpdateWhatsChangedEntryMutationVariables = {id: number;data: BodyType<WhatsChangedEntryUpdate>}

    /**
 * @summary Update a What's Changed entry (staff only)
 */
export const useUpdateWhatsChangedEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWhatsChangedEntry>>, TError,UpdateWhatsChangedEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWhatsChangedEntry>>,
        TError,
        UpdateWhatsChangedEntryMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWhatsChangedEntryMutationOptions(options), queryClient);
    }

export const getDeleteWhatsChangedEntryUrl = (id: number,) => {




  return `/api/whats-changed/${id}`
}

/**
 * @summary Delete a What's Changed entry (staff only)
 */
export const deleteWhatsChangedEntry = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteWhatsChangedEntryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteWhatsChangedEntryMutationKey = () => ['deleteWhatsChangedEntry'] as const;

export const getDeleteWhatsChangedEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsChangedEntry>>, TError,DeleteWhatsChangedEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsChangedEntry>>, TError,DeleteWhatsChangedEntryMutationVariables, TContext> => {

const mutationKey = getDeleteWhatsChangedEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWhatsChangedEntry>>, DeleteWhatsChangedEntryMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteWhatsChangedEntry(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWhatsChangedEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWhatsChangedEntry>>>

    export type DeleteWhatsChangedEntryMutationError = ErrorType<unknown>
    export type DeleteWhatsChangedEntryMutationVariables = {id: number}

    /**
 * @summary Delete a What's Changed entry (staff only)
 */
export const useDeleteWhatsChangedEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWhatsChangedEntry>>, TError,DeleteWhatsChangedEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWhatsChangedEntry>>,
        TError,
        DeleteWhatsChangedEntryMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWhatsChangedEntryMutationOptions(options), queryClient);
    }

export const getListReportsUrl = (params?: ListReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports?${stringifiedParams}` : `/api/reports`
}

/**
 * @summary List all bug reports (staff only)
 */
export const listReports = async (params?: ListReportsParams, options?: Parameters<typeof customFetch>[1]): Promise<Report[]> => {

  return customFetch<Report[]>(getListReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReportsQueryKey = (params?: ListReportsParams,) => {
    return [
    `/api/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReportsQueryOptions = <TData = Awaited<ReturnType<typeof listReports>>, TError = ErrorType<unknown>>(params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReports>>> = ({ signal }) => listReports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listReports>>>
export type ListReportsQueryError = ErrorType<unknown>


export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ErrorType<unknown>>(
 params: undefined |  ListReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReports>>,
          TError,
          Awaited<ReturnType<typeof listReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ErrorType<unknown>>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReports>>,
          TError,
          Awaited<ReturnType<typeof listReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ErrorType<unknown>>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all bug reports (staff only)
 */

export function useListReports<TData = Awaited<ReturnType<typeof listReports>>, TError = ErrorType<unknown>>(
 params?: ListReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReportUrl = () => {




  return `/api/reports`
}

/**
 * @summary Submit a new bug report (public)
 */
export const createReport = async (reportInput: ReportInput, options?: Parameters<typeof customFetch>[1]): Promise<Report> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Report>(getCreateReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportInput)
  }
);}





export const getCreateReportMutationKey = () => ['createReport'] as const;

export const getCreateReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext> => {

const mutationKey = getCreateReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReport>>, CreateReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof createReport>>>
    export type CreateReportMutationBody = BodyType<ReportInput>
    export type CreateReportMutationError = ErrorType<unknown>
    export type CreateReportMutationVariables = {data: BodyType<ReportInput>}

    /**
 * @summary Submit a new bug report (public)
 */
export const useCreateReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReport>>,
        TError,
        CreateReportMutationVariables,
        TContext
      > => {
      return useMutation(getCreateReportMutationOptions(options), queryClient);
    }

export const getRequestReportLookupLinkUrl = () => {




  return `/api/reports/lookup/request`
}

/**
 * @summary Request an emailed access link for report lookup (public)
 */
export const requestReportLookupLink = async (lookupLinkRequest: LookupLinkRequest, options?: Parameters<typeof customFetch>[1]): Promise<LookupLinkResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LookupLinkResult>(getRequestReportLookupLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(lookupLinkRequest)
  }
);}





export const getRequestReportLookupLinkMutationKey = () => ['requestReportLookupLink'] as const;

export const getRequestReportLookupLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestReportLookupLink>>, TError,RequestReportLookupLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestReportLookupLink>>, TError,RequestReportLookupLinkMutationVariables, TContext> => {

const mutationKey = getRequestReportLookupLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestReportLookupLink>>, RequestReportLookupLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestReportLookupLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestReportLookupLinkMutationResult = NonNullable<Awaited<ReturnType<typeof requestReportLookupLink>>>
    export type RequestReportLookupLinkMutationBody = BodyType<LookupLinkRequest>
    export type RequestReportLookupLinkMutationError = ErrorType<void>
    export type RequestReportLookupLinkMutationVariables = {data: BodyType<LookupLinkRequest>}

    /**
 * @summary Request an emailed access link for report lookup (public)
 */
export const useRequestReportLookupLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestReportLookupLink>>, TError,RequestReportLookupLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestReportLookupLink>>,
        TError,
        RequestReportLookupLinkMutationVariables,
        TContext
      > => {
      return useMutation(getRequestReportLookupLinkMutationOptions(options), queryClient);
    }

export const getLookupReportsUrl = (params: LookupReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/lookup?${stringifiedParams}` : `/api/reports/lookup`
}

/**
 * @summary Look up bug reports with an emailed access token (public)
 */
export const lookupReports = async (params: LookupReportsParams, options?: Parameters<typeof customFetch>[1]): Promise<ReportWithComments[]> => {

  return customFetch<ReportWithComments[]>(getLookupReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLookupReportsQueryKey = (params?: LookupReportsParams,) => {
    return [
    `/api/reports/lookup`, ...(params ? [params] : [])
    ] as const;
    }


export const getLookupReportsQueryOptions = <TData = Awaited<ReturnType<typeof lookupReports>>, TError = ErrorType<void>>(params: LookupReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupReports>>> = ({ signal }) => lookupReports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LookupReportsQueryResult = NonNullable<Awaited<ReturnType<typeof lookupReports>>>
export type LookupReportsQueryError = ErrorType<void>


export function useLookupReports<TData = Awaited<ReturnType<typeof lookupReports>>, TError = ErrorType<void>>(
 params: LookupReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupReports>>,
          TError,
          Awaited<ReturnType<typeof lookupReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupReports<TData = Awaited<ReturnType<typeof lookupReports>>, TError = ErrorType<void>>(
 params: LookupReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupReports>>,
          TError,
          Awaited<ReturnType<typeof lookupReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLookupReports<TData = Awaited<ReturnType<typeof lookupReports>>, TError = ErrorType<void>>(
 params: LookupReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Look up bug reports with an emailed access token (public)
 */

export function useLookupReports<TData = Awaited<ReturnType<typeof lookupReports>>, TError = ErrorType<void>>(
 params: LookupReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLookupReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReportUrl = (id: number,) => {




  return `/api/reports/${id}`
}

/**
 * @summary Get a single bug report (staff only)
 */
export const getReport = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ReportWithComments> => {

  return customFetch<ReportWithComments>(getGetReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportQueryKey = (id: number,) => {
    return [
    `/api/reports/${id}`
    ] as const;
    }


export const getGetReportQueryOptions = <TData = Awaited<ReturnType<typeof getReport>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) => getReport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>
export type GetReportQueryError = ErrorType<void>


export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single bug report (staff only)
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateReportUrl = (id: number,) => {




  return `/api/reports/${id}`
}

/**
 * @summary Update a bug report status (staff only)
 */
export const updateReport = async (id: number,
    reportUpdate: ReportUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Report> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Report>(getUpdateReportUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportUpdate)
  }
);}





export const getUpdateReportMutationKey = () => ['updateReport'] as const;

export const getUpdateReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReport>>, TError,UpdateReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReport>>, TError,UpdateReportMutationVariables, TContext> => {

const mutationKey = getUpdateReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReport>>, UpdateReportMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateReport(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReportMutationResult = NonNullable<Awaited<ReturnType<typeof updateReport>>>
    export type UpdateReportMutationBody = BodyType<ReportUpdate>
    export type UpdateReportMutationError = ErrorType<unknown>
    export type UpdateReportMutationVariables = {id: number;data: BodyType<ReportUpdate>}

    /**
 * @summary Update a bug report status (staff only)
 */
export const useUpdateReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReport>>, TError,UpdateReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReport>>,
        TError,
        UpdateReportMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateReportMutationOptions(options), queryClient);
    }

export const getLinkReportDuplicateUrl = (id: number,) => {




  return `/api/reports/${id}/link`
}

/**
 * @summary Link a report as a duplicate of a primary issue (staff only)
 */
export const linkReportDuplicate = async (id: number,
    linkDuplicateInput: LinkDuplicateInput, options?: Parameters<typeof customFetch>[1]): Promise<Report> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Report>(getLinkReportDuplicateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(linkDuplicateInput)
  }
);}





export const getLinkReportDuplicateMutationKey = () => ['linkReportDuplicate'] as const;

export const getLinkReportDuplicateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkReportDuplicate>>, TError,LinkReportDuplicateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkReportDuplicate>>, TError,LinkReportDuplicateMutationVariables, TContext> => {

const mutationKey = getLinkReportDuplicateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkReportDuplicate>>, LinkReportDuplicateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  linkReportDuplicate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkReportDuplicateMutationResult = NonNullable<Awaited<ReturnType<typeof linkReportDuplicate>>>
    export type LinkReportDuplicateMutationBody = BodyType<LinkDuplicateInput>
    export type LinkReportDuplicateMutationError = ErrorType<void>
    export type LinkReportDuplicateMutationVariables = {id: number;data: BodyType<LinkDuplicateInput>}

    /**
 * @summary Link a report as a duplicate of a primary issue (staff only)
 */
export const useLinkReportDuplicate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkReportDuplicate>>, TError,LinkReportDuplicateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkReportDuplicate>>,
        TError,
        LinkReportDuplicateMutationVariables,
        TContext
      > => {
      return useMutation(getLinkReportDuplicateMutationOptions(options), queryClient);
    }

export const getUnlinkReportDuplicateUrl = (id: number,) => {




  return `/api/reports/${id}/link`
}

/**
 * @summary Unlink a report from its primary issue (staff only)
 */
export const unlinkReportDuplicate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Report> => {

  return customFetch<Report>(getUnlinkReportDuplicateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkReportDuplicateMutationKey = () => ['unlinkReportDuplicate'] as const;

export const getUnlinkReportDuplicateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkReportDuplicate>>, TError,UnlinkReportDuplicateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkReportDuplicate>>, TError,UnlinkReportDuplicateMutationVariables, TContext> => {

const mutationKey = getUnlinkReportDuplicateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkReportDuplicate>>, UnlinkReportDuplicateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unlinkReportDuplicate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkReportDuplicateMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkReportDuplicate>>>

    export type UnlinkReportDuplicateMutationError = ErrorType<void>
    export type UnlinkReportDuplicateMutationVariables = {id: number}

    /**
 * @summary Unlink a report from its primary issue (staff only)
 */
export const useUnlinkReportDuplicate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkReportDuplicate>>, TError,UnlinkReportDuplicateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkReportDuplicate>>,
        TError,
        UnlinkReportDuplicateMutationVariables,
        TContext
      > => {
      return useMutation(getUnlinkReportDuplicateMutationOptions(options), queryClient);
    }

export const getListReportAttachmentsUrl = (id: number,) => {




  return `/api/reports/${id}/attachments`
}

/**
 * @summary List attachments for a bug report (public)
 */
export const listReportAttachments = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ReportAttachment[]> => {

  return customFetch<ReportAttachment[]>(getListReportAttachmentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReportAttachmentsQueryKey = (id: number,) => {
    return [
    `/api/reports/${id}/attachments`
    ] as const;
    }


export const getListReportAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof listReportAttachments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAttachments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReportAttachmentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReportAttachments>>> = ({ signal }) => listReportAttachments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReportAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReportAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listReportAttachments>>>
export type ListReportAttachmentsQueryError = ErrorType<unknown>


export function useListReportAttachments<TData = Awaited<ReturnType<typeof listReportAttachments>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportAttachments>>,
          TError,
          Awaited<ReturnType<typeof listReportAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReportAttachments<TData = Awaited<ReturnType<typeof listReportAttachments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportAttachments>>,
          TError,
          Awaited<ReturnType<typeof listReportAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReportAttachments<TData = Awaited<ReturnType<typeof listReportAttachments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAttachments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List attachments for a bug report (public)
 */

export function useListReportAttachments<TData = Awaited<ReturnType<typeof listReportAttachments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAttachments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReportAttachmentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned upload URL for an attachment
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: Parameters<typeof customFetch>[1]): Promise<UploadUrlResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UploadUrlResult>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestUploadUrlMutationKey = () => ['requestUploadUrl'] as const;

export const getRequestUploadUrlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext> => {

const mutationKey = getRequestUploadUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, RequestUploadUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<unknown>
    export type RequestUploadUrlMutationVariables = {data: BodyType<UploadUrlRequest>}

    /**
 * @summary Request a presigned upload URL for an attachment
 */
export const useRequestUploadUrl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        RequestUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options), queryClient);
    }

export const getSaveReportAttachmentUrl = (id: number,
    attachmentId: string,) => {




  return `/api/reports/${id}/attachments/${attachmentId}`
}

/**
 * @summary Save attachment metadata after upload
 */
export const saveReportAttachment = async (id: number,
    attachmentId: string,
    attachmentSaveInput: AttachmentSaveInput, options?: Parameters<typeof customFetch>[1]): Promise<ReportAttachment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportAttachment>(getSaveReportAttachmentUrl(id,attachmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(attachmentSaveInput)
  }
);}





export const getSaveReportAttachmentMutationKey = () => ['saveReportAttachment'] as const;

export const getSaveReportAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveReportAttachment>>, TError,SaveReportAttachmentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveReportAttachment>>, TError,SaveReportAttachmentMutationVariables, TContext> => {

const mutationKey = getSaveReportAttachmentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveReportAttachment>>, SaveReportAttachmentMutationVariables> = (props) => {
          const {id,attachmentId,data} = props ?? {};

          return  saveReportAttachment(id,attachmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveReportAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof saveReportAttachment>>>
    export type SaveReportAttachmentMutationBody = BodyType<AttachmentSaveInput>
    export type SaveReportAttachmentMutationError = ErrorType<unknown>
    export type SaveReportAttachmentMutationVariables = {id: number;attachmentId: string;data: BodyType<AttachmentSaveInput>}

    /**
 * @summary Save attachment metadata after upload
 */
export const useSaveReportAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveReportAttachment>>, TError,SaveReportAttachmentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveReportAttachment>>,
        TError,
        SaveReportAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getSaveReportAttachmentMutationOptions(options), queryClient);
    }

export const getListCommentsUrl = (id: number,) => {




  return `/api/reports/${id}/comments`
}

/**
 * @summary List comments for a bug report
 */
export const listComments = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Comment[]> => {

  return customFetch<Comment[]>(getListCommentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCommentsQueryKey = (id: number,) => {
    return [
    `/api/reports/${id}/comments`
    ] as const;
    }


export const getListCommentsQueryOptions = <TData = Awaited<ReturnType<typeof listComments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCommentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listComments>>> = ({ signal }) => listComments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listComments>>>
export type ListCommentsQueryError = ErrorType<unknown>


export function useListComments<TData = Awaited<ReturnType<typeof listComments>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listComments>>,
          TError,
          Awaited<ReturnType<typeof listComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListComments<TData = Awaited<ReturnType<typeof listComments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listComments>>,
          TError,
          Awaited<ReturnType<typeof listComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListComments<TData = Awaited<ReturnType<typeof listComments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List comments for a bug report
 */

export function useListComments<TData = Awaited<ReturnType<typeof listComments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCommentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCommentUrl = (id: number,) => {




  return `/api/reports/${id}/comments`
}

/**
 * @summary Add a comment to a bug report (staff only)
 */
export const createComment = async (id: number,
    commentInput: CommentInput, options?: Parameters<typeof customFetch>[1]): Promise<Comment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Comment>(getCreateCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(commentInput)
  }
);}





export const getCreateCommentMutationKey = () => ['createComment'] as const;

export const getCreateCommentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComment>>, TError,CreateCommentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createComment>>, TError,CreateCommentMutationVariables, TContext> => {

const mutationKey = getCreateCommentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComment>>, CreateCommentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createComment>>>
    export type CreateCommentMutationBody = BodyType<CommentInput>
    export type CreateCommentMutationError = ErrorType<unknown>
    export type CreateCommentMutationVariables = {id: number;data: BodyType<CommentInput>}

    /**
 * @summary Add a comment to a bug report (staff only)
 */
export const useCreateComment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComment>>, TError,CreateCommentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createComment>>,
        TError,
        CreateCommentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCommentMutationOptions(options), queryClient);
    }

export const getListAuditLogsUrl = (params?: ListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-logs?${stringifiedParams}` : `/api/audit-logs`
}

/**
 * @summary List audit log entries (staff only)
 */
export const listAuditLogs = async (params?: ListAuditLogsParams, options?: Parameters<typeof customFetch>[1]): Promise<AuditLog[]> => {

  return customFetch<AuditLog[]>(getListAuditLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    `/api/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<unknown>


export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params: undefined |  ListAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit log entries (staff only)
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListReportAuditLogsUrl = (id: number,) => {




  return `/api/reports/${id}/audit-logs`
}

/**
 * @summary List audit log entries for a specific report (staff only)
 */
export const listReportAuditLogs = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AuditLog[]> => {

  return customFetch<AuditLog[]>(getListReportAuditLogsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReportAuditLogsQueryKey = (id: number,) => {
    return [
    `/api/reports/${id}/audit-logs`
    ] as const;
    }


export const getListReportAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listReportAuditLogs>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReportAuditLogsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReportAuditLogs>>> = ({ signal }) => listReportAuditLogs(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReportAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReportAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listReportAuditLogs>>>
export type ListReportAuditLogsQueryError = ErrorType<unknown>


export function useListReportAuditLogs<TData = Awaited<ReturnType<typeof listReportAuditLogs>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listReportAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReportAuditLogs<TData = Awaited<ReturnType<typeof listReportAuditLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listReportAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReportAuditLogs<TData = Awaited<ReturnType<typeof listReportAuditLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit log entries for a specific report (staff only)
 */

export function useListReportAuditLogs<TData = Awaited<ReturnType<typeof listReportAuditLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReportAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReportAuditLogsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDraftsUrl = (params?: ListDraftsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/drafts?${stringifiedParams}` : `/api/drafts`
}

/**
 * @summary List drafts Claude proposed, newest first (staff only)
 */
export const listDrafts = async (params?: ListDraftsParams, options?: Parameters<typeof customFetch>[1]): Promise<Draft[]> => {

  return customFetch<Draft[]>(getListDraftsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDraftsQueryKey = (params?: ListDraftsParams,) => {
    return [
    `/api/drafts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDraftsQueryOptions = <TData = Awaited<ReturnType<typeof listDrafts>>, TError = ErrorType<unknown>>(params?: ListDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDraftsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDrafts>>> = ({ signal }) => listDrafts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDrafts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listDrafts>>>
export type ListDraftsQueryError = ErrorType<unknown>


export function useListDrafts<TData = Awaited<ReturnType<typeof listDrafts>>, TError = ErrorType<unknown>>(
 params: undefined |  ListDraftsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDrafts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDrafts>>,
          TError,
          Awaited<ReturnType<typeof listDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDrafts<TData = Awaited<ReturnType<typeof listDrafts>>, TError = ErrorType<unknown>>(
 params?: ListDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDrafts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDrafts>>,
          TError,
          Awaited<ReturnType<typeof listDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDrafts<TData = Awaited<ReturnType<typeof listDrafts>>, TError = ErrorType<unknown>>(
 params?: ListDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List drafts Claude proposed, newest first (staff only)
 */

export function useListDrafts<TData = Awaited<ReturnType<typeof listDrafts>>, TError = ErrorType<unknown>>(
 params?: ListDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDraftsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApplyDraftUrl = (id: number,) => {




  return `/api/drafts/${id}/apply`
}

/**
 * @summary Apply a pending draft as the signed-in staff member (staff only)
 */
export const applyDraft = async (id: number,
    draftApplyInput?: DraftApplyInput, options?: Parameters<typeof customFetch>[1]): Promise<Draft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Draft>(getApplyDraftUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(draftApplyInput)
  }
);}





export const getApplyDraftMutationKey = () => ['applyDraft'] as const;

export const getApplyDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyDraft>>, TError,ApplyDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyDraft>>, TError,ApplyDraftMutationVariables, TContext> => {

const mutationKey = getApplyDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyDraft>>, ApplyDraftMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  applyDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyDraftMutationResult = NonNullable<Awaited<ReturnType<typeof applyDraft>>>
    export type ApplyDraftMutationBody = BodyType<DraftApplyInput> | undefined
    export type ApplyDraftMutationError = ErrorType<void>
    export type ApplyDraftMutationVariables = {id: number;data?: BodyType<DraftApplyInput>}

    /**
 * @summary Apply a pending draft as the signed-in staff member (staff only)
 */
export const useApplyDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyDraft>>, TError,ApplyDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyDraft>>,
        TError,
        ApplyDraftMutationVariables,
        TContext
      > => {
      return useMutation(getApplyDraftMutationOptions(options), queryClient);
    }

export const getDiscardDraftUrl = (id: number,) => {




  return `/api/drafts/${id}/discard`
}

/**
 * @summary Discard a pending or failed draft (staff only)
 */
export const discardDraft = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Draft> => {

  return customFetch<Draft>(getDiscardDraftUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDiscardDraftMutationKey = () => ['discardDraft'] as const;

export const getDiscardDraftMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardDraft>>, TError,DiscardDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof discardDraft>>, TError,DiscardDraftMutationVariables, TContext> => {

const mutationKey = getDiscardDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardDraft>>, DiscardDraftMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  discardDraft(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardDraftMutationResult = NonNullable<Awaited<ReturnType<typeof discardDraft>>>

    export type DiscardDraftMutationError = ErrorType<void>
    export type DiscardDraftMutationVariables = {id: number}

    /**
 * @summary Discard a pending or failed draft (staff only)
 */
export const useDiscardDraft = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardDraft>>, TError,DiscardDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discardDraft>>,
        TError,
        DiscardDraftMutationVariables,
        TContext
      > => {
      return useMutation(getDiscardDraftMutationOptions(options), queryClient);
    }

export const getGetOAuthConsentRequestUrl = (id: string,) => {




  return `/api/oauth/requests/${id}`
}

/**
 * @summary Details of a pending MCP client connection request for the consent page (staff only)
 */
export const getOAuthConsentRequest = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OAuthConsentRequest> => {

  return customFetch<OAuthConsentRequest>(getGetOAuthConsentRequestUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOAuthConsentRequestQueryKey = (id: string,) => {
    return [
    `/api/oauth/requests/${id}`
    ] as const;
    }


export const getGetOAuthConsentRequestQueryOptions = <TData = Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOAuthConsentRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOAuthConsentRequest>>> = ({ signal }) => getOAuthConsentRequest(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOAuthConsentRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getOAuthConsentRequest>>>
export type GetOAuthConsentRequestQueryError = ErrorType<void>


export function useGetOAuthConsentRequest<TData = Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOAuthConsentRequest>>,
          TError,
          Awaited<ReturnType<typeof getOAuthConsentRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOAuthConsentRequest<TData = Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOAuthConsentRequest>>,
          TError,
          Awaited<ReturnType<typeof getOAuthConsentRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOAuthConsentRequest<TData = Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Details of a pending MCP client connection request for the consent page (staff only)
 */

export function useGetOAuthConsentRequest<TData = Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOAuthConsentRequest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOAuthConsentRequestQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveOAuthConsentRequestUrl = (id: string,) => {




  return `/api/oauth/requests/${id}/approve`
}

/**
 * @summary Approve an MCP client connection request as the signed-in staff member (staff only)
 */
export const approveOAuthConsentRequest = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OAuthConsentDecision> => {

  return customFetch<OAuthConsentDecision>(getApproveOAuthConsentRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveOAuthConsentRequestMutationKey = () => ['approveOAuthConsentRequest'] as const;

export const getApproveOAuthConsentRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOAuthConsentRequest>>, TError,ApproveOAuthConsentRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveOAuthConsentRequest>>, TError,ApproveOAuthConsentRequestMutationVariables, TContext> => {

const mutationKey = getApproveOAuthConsentRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveOAuthConsentRequest>>, ApproveOAuthConsentRequestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  approveOAuthConsentRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveOAuthConsentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveOAuthConsentRequest>>>

    export type ApproveOAuthConsentRequestMutationError = ErrorType<void>
    export type ApproveOAuthConsentRequestMutationVariables = {id: string}

    /**
 * @summary Approve an MCP client connection request as the signed-in staff member (staff only)
 */
export const useApproveOAuthConsentRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveOAuthConsentRequest>>, TError,ApproveOAuthConsentRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveOAuthConsentRequest>>,
        TError,
        ApproveOAuthConsentRequestMutationVariables,
        TContext
      > => {
      return useMutation(getApproveOAuthConsentRequestMutationOptions(options), queryClient);
    }

export const getDenyOAuthConsentRequestUrl = (id: string,) => {




  return `/api/oauth/requests/${id}/deny`
}

/**
 * @summary Deny an MCP client connection request (staff only)
 */
export const denyOAuthConsentRequest = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OAuthConsentDecision> => {

  return customFetch<OAuthConsentDecision>(getDenyOAuthConsentRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDenyOAuthConsentRequestMutationKey = () => ['denyOAuthConsentRequest'] as const;

export const getDenyOAuthConsentRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyOAuthConsentRequest>>, TError,DenyOAuthConsentRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof denyOAuthConsentRequest>>, TError,DenyOAuthConsentRequestMutationVariables, TContext> => {

const mutationKey = getDenyOAuthConsentRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyOAuthConsentRequest>>, DenyOAuthConsentRequestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  denyOAuthConsentRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyOAuthConsentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof denyOAuthConsentRequest>>>

    export type DenyOAuthConsentRequestMutationError = ErrorType<void>
    export type DenyOAuthConsentRequestMutationVariables = {id: string}

    /**
 * @summary Deny an MCP client connection request (staff only)
 */
export const useDenyOAuthConsentRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyOAuthConsentRequest>>, TError,DenyOAuthConsentRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof denyOAuthConsentRequest>>,
        TError,
        DenyOAuthConsentRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDenyOAuthConsentRequestMutationOptions(options), queryClient);
    }

export const getListOAuthConnectionsUrl = () => {




  return `/api/oauth/connections`
}

/**
 * @summary The signed-in staff member's live MCP client connections (staff only)
 */
export const listOAuthConnections = async ( options?: Parameters<typeof customFetch>[1]): Promise<OAuthConnection[]> => {

  return customFetch<OAuthConnection[]>(getListOAuthConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOAuthConnectionsQueryKey = () => {
    return [
    `/api/oauth/connections`
    ] as const;
    }


export const getListOAuthConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listOAuthConnections>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOAuthConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOAuthConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOAuthConnections>>> = ({ signal }) => listOAuthConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOAuthConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOAuthConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listOAuthConnections>>>
export type ListOAuthConnectionsQueryError = ErrorType<unknown>


export function useListOAuthConnections<TData = Awaited<ReturnType<typeof listOAuthConnections>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOAuthConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOAuthConnections>>,
          TError,
          Awaited<ReturnType<typeof listOAuthConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOAuthConnections<TData = Awaited<ReturnType<typeof listOAuthConnections>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOAuthConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOAuthConnections>>,
          TError,
          Awaited<ReturnType<typeof listOAuthConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOAuthConnections<TData = Awaited<ReturnType<typeof listOAuthConnections>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOAuthConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in staff member's live MCP client connections (staff only)
 */

export function useListOAuthConnections<TData = Awaited<ReturnType<typeof listOAuthConnections>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOAuthConnections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOAuthConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRevokeOAuthConnectionUrl = (id: string,) => {




  return `/api/oauth/connections/${id}`
}

/**
 * @summary Revoke one of the signed-in staff member's MCP client connections (staff only)
 */
export const revokeOAuthConnection = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRevokeOAuthConnectionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeOAuthConnectionMutationKey = () => ['revokeOAuthConnection'] as const;

export const getRevokeOAuthConnectionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOAuthConnection>>, TError,RevokeOAuthConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeOAuthConnection>>, TError,RevokeOAuthConnectionMutationVariables, TContext> => {

const mutationKey = getRevokeOAuthConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOAuthConnection>>, RevokeOAuthConnectionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  revokeOAuthConnection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeOAuthConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOAuthConnection>>>

    export type RevokeOAuthConnectionMutationError = ErrorType<void>
    export type RevokeOAuthConnectionMutationVariables = {id: string}

    /**
 * @summary Revoke one of the signed-in staff member's MCP client connections (staff only)
 */
export const useRevokeOAuthConnection = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOAuthConnection>>, TError,RevokeOAuthConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeOAuthConnection>>,
        TError,
        RevokeOAuthConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeOAuthConnectionMutationOptions(options), queryClient);
    }

